<cb-dialog>
    <form class="flex-col flex" #buildTemplateForm="ngForm">
        @if (data.baseTemplateName) {
            <cb-input
                label="Base Template"
                [readonly]="true"
                [ngModel]="data.baseTemplateName"
                [ngModelOptions]="{ standalone: true }"
            ></cb-input>
        }
        <cb-input
            label="Name"
            name="name"
            [required]="true"
            [(ngModel)]="mappedItem.name"
        ></cb-input>
        <mat-radio-group
            class="cb-margin-top-2x flex-col flex"
            [(ngModel)]="templateType"
            [ngModelOptions]="{ standalone: true }"
        >
            <mat-radio-button class="mat-accent" [value]="0">Nationwide Template </mat-radio-button>
            <mat-radio-button class="cb-margin-top business-enitities-radio" [value]="1">
                Regional Template
                <div class="flex-col flex">
                    @for (item of businessEnitities; track item) {
                        <cb-checkbox
                            [label]="item.name"
                            [name]="'region' + item.id"
                            [disabled]="templateType !== 1"
                            [ngModel]="isRegionChecked(item.id)"
                            (change)="templateType = 1; onRegionChanged(item.id, $event)"
                        ></cb-checkbox>
                    }
                </div>
            </mat-radio-button>
        </mat-radio-group>
        <cb-checkbox
            label="Active"
            name="isActive"
            class="cb-margin-top-2x"
            [(ngModel)]="mappedItem.isActive"
        ></cb-checkbox>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            (click)="onSaveClicked()"
            [disabled]="!buildTemplateForm.dirty || !buildTemplateForm.valid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
